import { cva } from 'class-variance-authority';

const avatarNameLabelBaseStyles = [
  'text-[15px]',
  'font-semibold',
  'flex',
  'overflow-hidden',
  'text-ellipsis',
  'whitespace-nowrap',
  'block',
  'select-none',
  'truncate',
];

const avatarNameLabelStylesSAG = cva([
  ...avatarNameLabelBaseStyles,
  'text-[#000028]',
  'dark:text-white',
]);

const avatarNameLabelStylesSHS = cva([
  ...avatarNameLabelBaseStyles,
  'text-[#666666]',
  'dark:text-white',
]);

export { avatarNameLabelStylesSAG, avatarNameLabelStylesSHS };
